<template>
  <div class="c-video" :style="styles" @click="$emit('click')">
    <em class="c-video-play"></em>
  </div>
</template>
<script>
import Compressor from 'compressorjs';
import { blobToBase64, urlToFile } from '@/utils/file';

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    poster: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    millisecond: {
      type: Number,
      default: 1000,
    },
  },
  components: {},
  data() {
    return {
      src90: '',
    };
  },
  computed: {
    styles() {
      if (!this.src90) return {};
      const backgroundImage = `url(${this.src90})`;
      return { backgroundImage };
    },
  },
  methods: {
    getUrl(src) {
      console.log(src);
      console.log('poster:', this.poster);
      if (this.poster) return this.poster;
      if (!src) return '';
      if (!/^http/.test(src)) return;
      const width = this.width ? `,w_${this.width}` : '';
      const height = this.height ? `h_${this.height}` : '';
      return `${src.split('?')[0]}?x-oss-process=video/snapshot,t_${this.millisecond}${width}${height},f_jpg&t=${new Date().getTime()}`;
    },
    async rotate90(src) {
      if (!src) return;
      const url = this.getUrl(src);
      console.log(url);
      const file = await urlToFile(url);
      const blob = await new Promise((resolve, reject) => {
        return new Compressor(file, {
          success: resolve,
          error: reject,
        });
      });
      const base64 = await blobToBase64(blob);
      this.src90 = base64;
    },
  },
  created() {
    this.src90 = this.getUrl(this.src);
    this.rotate90(this.src);
  },
  mounted() {},
  beforeUnmount() {},
  watch: {
    src(newValue) {
      this.src90 = this.getUrl(newValue);
      this.rotate90(newValue);
    },
  },
};
</script>
<style lang="scss">
.c-video {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 72px;
  height: 72px;
  background: #303030;
  // border-radius: 4px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  &-play {
    display: inline-block;
    width: 23px;
    height: 23px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-image: url('@/assets/images/play@2x.png');
    font-size: 20px;
    color: #e0e0e0;
    cursor: pointer;
  }
  &.large {
    width: 100%;
    height: 250px;
    .c-video-play {
      width: 43px;
      height: 43px;
    }
  }
}
</style>
